// extracted by mini-css-extract-plugin
export default {"review_card":"review-card_review_card__cEcDm"};